import Card from '@/components/ui/Card'

const items = [
  { type: 'image', src: '/gallery/1.jpg', alt: 'Robotics day' },
  { type: 'image', src: '/gallery/2.jpg', alt: 'Art supplies delivery' },
  { type: 'video', src: 'https://www.youtube.com/embed/VIDEO_ID', alt: 'Student demo' },
]

export default function Gallery() {
  return (
    <div className="space-y-8">
      <header>
        <h1 className="text-3xl font-semibold text-cocoa">Gallery</h1>
        <p className="text-cocoa/70">Photos and videos from our work and impact.</p>
      </header>

      <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-3">
        {items.map((it, i) => (
          <Card key={i} className="overflow-hidden">
            {it.type === 'image' ? (
              <img src={it.src} alt={it.alt} className="w-full h-48 object-cover" />
            ) : (
              <div className="aspect-video">
                <iframe
                  className="w-full h-full"
                  src={it.src}
                  title={it.alt}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            )}
            <div className="p-3 text-sm text-cocoa/70">{it.alt}</div>
          </Card>
        ))}
      </div>
    </div>
  )
}
